import { useState } from "react"
import "../Css/SharedByMeList.css"
import SharedGuestsModal from "./SharedGuestsModal"
import FileCard from "./FileCard"
import FileViewer from "./FileViewer"
import {db} from "../firebaseConect"
import { doc, deleteDoc } from "firebase/firestore";

export default function SharedByMeList({ sharedFiles }) {
  const [modalFile, setModalFile] = useState(null)
  const [files, setFiles] = useState(sharedFiles)
  const [selectedFile, setSelectedFile] = useState(null)
  const [isViewerOpen, setIsViewerOpen] = useState(false)

  const handleRemoved = (email) => {
    setFiles((prev) =>
      prev.map(f =>
        f.id === modalFile.id
          ? { ...f, sharedWith: f.sharedWith.filter(e => e !== email) }
          : f
      )
    )
  }

  if (!files || files.length === 0) {
    return <div className="shared-by-me-list">No has compartido archivos aún.</div>
  }

  return (
    <div className="shared-by-me-list">
      <h3>Archivos que compartiste</h3>
      <div className="file-grid">
        {files.map(file => (
          <FileCard
            key={file.id}
            file={file}
            onView={() => {
              setSelectedFile(file)
              setIsViewerOpen(true)
            }}
            extraActions={
              <>
                <button
                  className="action-btn"
                  style={{
                    marginLeft: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    fontSize: 20,
                    borderRadius: "50%",
                    background: "#f0f0f0",
                    border: "none",
                    cursor: "pointer"
                  }}
                  onClick={e => {
                    e.stopPropagation()
                    setModalFile(file)
                  }}
                  title="Ver invitados"
                >
                  <span role="img" aria-label="Invitados">👥</span>
                </button>
                <button
                  className="action-btn"
                  style={{
                    marginLeft: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    fontSize: 20,
                    borderRadius: "50%",
                    background: "#fee2e2",
                    border: "none",
                    cursor: "pointer"
                  }}
                  onClick={async e => {
                    e.stopPropagation()
                    if (window.confirm("¿Seguro que quieres dejar de compartir este archivo?")) {
                      await deleteDoc(doc(db, "sharedFile", file.id))
                      setFiles(prev => prev.filter(f => f.id !== file.id))
                      alert("Archivo ya no está compartido.")
                    }
                  }}
                  title="Dejar de compartir"
                >
                  <span role="img" aria-label="Dejar de compartir">🚫</span>
                </button>
              </>
            }
          />
        ))}
      </div>
      {modalFile && (
        <SharedGuestsModal
          fileId={modalFile.id}
          sharedWith={modalFile.sharedWith}
          onRemoved={handleRemoved}
          onClose={() => setModalFile(null)}
        />
      )}
      <FileViewer
        file={selectedFile}
        isOpen={isViewerOpen}
        onClose={() => {
          setIsViewerOpen(false)
          setSelectedFile(null)
        }}
      />
    </div>
  )
}